import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import BrutalButton from "@/components/common/BrutalButton";

export default function CTASection() {
    return (
        <section
            data-testid="cta-section"
            className="bg-brand-blue text-white border-b-4 border-ink py-24 md:py-32 relative overflow-hidden"
        >
            <div className="absolute inset-0 grain opacity-50 pointer-events-none" />
            <div className="absolute -top-16 -left-16 w-48 h-48 rounded-full bg-brand-yellow border-[3px] border-ink hidden md:block" />
            <div className="absolute -bottom-20 right-10 w-64 h-64 rounded-full bg-brand-orange border-[3px] border-ink hidden md:block" />

            <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
                <span className="label-mono inline-block bg-white text-ink border-2 border-ink rounded-full px-4 py-1.5">
                    Let's build
                </span>
                <h2 className="mt-6 font-display text-5xl sm:text-6xl lg:text-8xl font-black tracking-tighter leading-[0.9]">
                    Got a hard problem? <br />
                    <span className="bg-brand-yellow text-ink px-4 -rotate-1 inline-block border-2 border-ink shadow-brutal mt-3">
                        Forge it with us.
                    </span>
                </h2>
                <p className="mt-8 font-body text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
                    Tell us where you're stuck — software, SaaS, or marketing —
                    and we'll send a 1-page plan within 48 hours.
                </p>
                <div className="mt-10 flex flex-wrap gap-4 justify-center">
                    <BrutalButton
                        as={Link}
                        to="/contact"
                        size="lg"
                        variant="yellow"
                        data-testid="cta-section-primary"
                    >
                        Book a discovery call <ArrowUpRight size={18} />
                    </BrutalButton>
                    <BrutalButton
                        as={Link}
                        to="/services"
                        size="lg"
                        variant="white"
                        data-testid="cta-section-secondary"
                    >
                        See services
                    </BrutalButton>
                </div>
            </div>
        </section>
    );
}
